/** Read twice below, which the table cannot do to itself. */
const IMAGES = 'Bilder'

// Things that are reused everywhere, like "Confirm" and "Cancel" on buttons
export const COMMON = {
  yes: 'Ja',
  no: 'Nein',
  today: 'Heute',
  total: 'Gesamt',
  /** A figure in euros, wherever one is typed and the field is not the thing
   *  it is a price of. */
  amount: 'Betrag',
  other: 'Sonstige',
  active: 'Aktiv',
  filter: 'Filter',
  sort: 'Sortieren',
  /** Narrows a list to what nothing points at. */
  onlyUnused: 'Nur unbenutzte',
  /** Said in place of a name where the account behind a record is gone. Every
   *  surface that outlives its author says it — a comment, the team activity
   *  list — so it is said once. */
  deletedAccount: 'Gelöschtes Konto',
  apply: 'Übernehmen',
  pause: 'Pausieren',
  save: 'Speichern',
  enabled: 'Aktiviert',
  disabled: 'Deaktiviert',
  cancel: 'Abbrechen',
  discard: 'Verwerfen',
  /** Heads the question a screen asks before it drops what somebody typed. */
  unsavedChanges: 'Ungespeicherte Änderungen',
  submit: 'Absenden',
  notSpecified: 'Nicht angegeben',
  from: 'ab',
  to: 'bis',
  /** Reads out an alternative — one of several rows, one of several choices. */
  or: 'oder',
  rename: 'Umbenennen',
  remove: 'Entfernen',
  removeNamed: (name: string) => `${name} entfernen`,
  uploading: 'Wird hochgeladen …',
  metadata: 'Metadaten',
  // HTTP verb of a request. IT vocabulary, so it stays English.
  httpMethod: 'Method',
  password: 'Passwort',
  newPassword: 'Neues Passwort',
  send: 'Senden',
  optional: 'optional',
  confirm: 'Bestätigen',
  close: 'Schließen',
  download: 'Herunterladen',
  size: 'Größe',
  error: 'Fehler',
  loading: 'Wird geladen …',
  type: 'Typ',
  designation: 'Bezeichnung',
  /** What something will look like, or come to, before it is saved. A bare
   *  word carrying no domain noun, so every surface reads it from here. */
  preview: 'Vorschau',
  /** Somebody has looked at it — what clears a flag that asked them to. */
  checked: 'Geprüft',
  /** The column counting what reads an entry. A bare word carrying no domain
   *  noun, so every branch that has such a column reads it from here. */
  usedIn: 'Verwendet in',
  /** What a new row is seeded from — a measure's stages, an email. */
  template: 'Vorlage',
  decimalPlaces: 'Nachkommastellen',
  customerVisible: 'Für Kunden sichtbar',
  jobAlreadyRunning: (triggeredBy: string) =>
    `Läuft bereits — gestartet von ${triggeredBy}.`,
  jobSwitchedOff: 'Ist ausgeschaltet. Erst einschalten, dann starten.',
  saving: 'Speichert …',
  savedShort: 'Gespeichert',
  imageUnavailable: 'Bild nicht verfügbar',
  untitled: 'Ohne Titel',
  delete: 'Löschen',
  /** What a bulk delete came back with. A guard keeps a referenced record. */
  bulkDeleteResult: (deleted: number, blocked: number) =>
    blocked === 0
      ? `${deleted} gelöscht`
      : `${deleted} gelöscht, ${blocked} noch in Verwendung`,
  deleteNamed: (name: string) => `${name} löschen`,
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  addNamed: (name: string) => `${name} hinzufügen`,
  editNamed: (name: string) => `${name} bearbeiten`,
  prev: 'Zurück',
  next: 'Weiter',
  created: 'Erfolgreich erstellt',
  saved: 'Änderung gespeichert',
  undo: 'Rückgängig machen',
  undone: 'Änderung rückgängig gemacht',
  retry: 'Erneut versuchen',
  deleted: 'Erfolgreich gelöscht',
  restore: 'Wiederherstellen',
  restored: 'Erfolgreich wiederhergestellt',
  images: IMAGES,
  /** The noun in whichever number the count in front of it asks for. */
  imageUnit: (count: number) => (count === 1 ? 'Bild' : IMAGES),
  addPictures: 'Bilder hinzufügen',
  details: 'Details',
  zoomIn: 'Vergrößern',
  zoomOut: 'Verkleinern',
  general: 'Allgemein',
  backToHome: 'Zurück zur Startseite',
  // German writes the unit after a clock reading; `formatTime` returns only the
  // digits, so the word is a suffix rather than part of the format.
  clockTime: (time: string) => `${time} Uhr`,
  // Marks a form field as optional without duplicating its canonical label
  // from the `fields` namespace.
  optionalLabel: (label: string) => `${label} (optional)`,
  errors: {
    networkError: 'Netzwerkfehler. Bitte versuche es erneut.',
    saveFailed: 'Speichern fehlgeschlagen',
    deleteFailed: 'Löschen fehlgeschlagen',
    loadFailed: 'Laden fehlgeschlagen',
    notFound: 'Der Eintrag existiert nicht mehr. Bitte lade die Seite neu.',
    forbidden: 'Dafür fehlt dir die Berechtigung.',
    // What an ErrorBoundary shows in place of the subtree it caught, when the
    // thrown Error carries no message of its own.
    renderFailed: 'Konnte nicht geladen werden',
    unexpected: 'Etwas ist schiefgelaufen.',
  },
  /** Drops a multi-select without acting on it. */
  clearSelection: 'Auswahl aufheben',
} as const
